import _Handlebars2 from '../../../../../packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js';
import { View, createButton } from '../../../../../packages/@okta/courage-dist/esm/src/CourageForSigninWidget.js';
import '../../../../../packages/@okta/courage-dist/esm/src/courage/framework/Model.js';
import '../../../../../packages/@okta/courage-dist/esm/src/courage/vendor/lib/backbone.js';
import '../../../../../packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js';
import '../../../../../packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js';
import '../../../../../packages/@okta/courage-dist/esm/src/courage/models/Model.js';
import '../../../../../packages/@okta/courage-dist/esm/src/courage/models/BaseModel.js';
import '../../../../../packages/@okta/courage-dist/esm/src/courage/framework/View.js';
import '../../../../../packages/@okta/courage-dist/esm/src/courage/views/Backbone.ListView.js';

const IDP_SEARCH_THRESHOLD = 10;
var signInWithIdps = View.extend({
  className: 'sign-in-with-idp',
  template: _Handlebars2.template({
    "1": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return "<div class=\"separation-line\"><span>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "socialauth.divider.text"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 64
          },
          "end": {
            "line": 1,
            "column": 118
          }
        }
      })) + "</span></div>";
    },
    "3": function (container, depth0, helpers, partials, data) {
      var alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<div class=\"okta-piv-container\"></div><div class=\"idp-discovery-container\"><label class=\"idp-discovery-search-label\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "idps.search.label"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 282
          },
          "end": {
            "line": 1,
            "column": 330
          }
        }
      })) + "</label><div class=\"idp-discovery-search-wrapper\"><input type=\"search\" class=\"idp-discovery-search-input\" data-se=\"idp-search-input\" aria-label=\"" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "idps.search.label"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 475
          },
          "end": {
            "line": 1,
            "column": 523
          }
        }
      })) + "\" placeholder=\"" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "idps.search.typeahead.placeholder"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 538
          },
          "end": {
            "line": 1,
            "column": 602
          }
        }
      })) + "\" autocomplete=\"off\"></div><div class=\"okta-idps-container\" data-se=\"idp-list-container\"></div><div class=\"idp-no-results\" data-se=\"idp-no-results\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "idps.search.no.results"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 750
          },
          "end": {
            "line": 1,
            "column": 803
          }
        }
      })) + "</div></div>";
    },
    "5": function (container, depth0, helpers, partials, data) {
      return "<div class=\"okta-idps-container\"></div>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "isSecondaryIdpDisplay") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 138
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "showSearchContainer") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(3, data, 0),
        "inverse": container.program(5, data, 0),
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 138
          },
          "end": {
            "line": 1,
            "column": 869
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "isPrimaryIdpDisplay") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 869
          },
          "end": {
            "line": 1,
            "column": 1005
          }
        }
      })) != null ? stack1 : "");
    },
    "useData": true
  }),
  events: {
    'input .idp-discovery-search-input': '_filterIdps'
  },
  initialize: function () {
    const {
      idpButtons: idpButtons
    } = this.options;
    const showSearch = idpButtons.length > IDP_SEARCH_THRESHOLD;
    idpButtons.forEach(idpButton => {
      const isPiv = idpButton.className && idpButton.className.includes('piv-button');
      const selector = showSearch && isPiv ? '.okta-piv-container' : '.okta-idps-container';
      this.add(createButton(idpButton), selector);
    });
  },
  _filterIdps: function (e) {
    const query = e.target.value.toLowerCase().trim();
    let visibleCount = 0;
    this.$('.okta-idps-container .link-button').each((i, btn) => {
      const text = (btn.textContent || '').toLowerCase().trim();
      const visible = !query || text.includes(query);
      btn.style.display = visible ? '' : 'none';
      if (visible) {
        visibleCount++;
      }
    });
    if (visibleCount > 0) {
      this.$('.okta-idps-container').show();
      this.$('.idp-no-results').hide();
    } else {
      this.$('.okta-idps-container').hide();
      this.$('.idp-no-results').show();
    }
  },
  getTemplateData: function () {
    const jsonData = View.prototype.getTemplateData.apply(this, arguments);
    const {
      idpButtons: idpButtons
    } = this.options;
    const addDivider = idpButtons.length > 0;
    return Object.assign(jsonData, {
      isPrimaryIdpDisplay: addDivider && this.options.isPrimaryIdpDisplay,
      isSecondaryIdpDisplay: addDivider && !this.options.isPrimaryIdpDisplay,
      showSearchContainer: idpButtons.length > IDP_SEARCH_THRESHOLD
    });
  }
});

export { signInWithIdps as default };
//# sourceMappingURL=SignInWithIdps.js.map
